import React, { createContext, useContext, useMemo, useState } from 'react'
import {
  postCodigoResgate,
  postResgateAssinaturaPresente,
} from '../api/presente.servico'
import Toast from '@taglivros/oef_componentes/build/components/toast'

import { useGlobal } from '../contexts/GlobalContext'
import { isEmptyObject } from '../utils/helpers/helpers'
import { httpStatus, textoModalErro } from '../utils/request/httpStatus'
import { SUCESSO_RESGATE } from '../containers/AssinaturaPresente/constantsAssinaturaPresente'

const AssinaturaPresenteContext = createContext()

function AssinaturaPresenteProvider( props ) {
  const [ state, setState ] = useState( {
    'codigoResgate': '',
    'dadosAssinaturaPresente': {},
    'endereco': {},
    'erroCodigo': '',
  } )

  const value = useMemo( () => {
    return {
      setState,
      state
    }
  }, [ state ] )

  return (
    <AssinaturaPresenteContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function useAssinaturaPresente() {
  const context = useContext( AssinaturaPresenteContext )
  if ( !context ) {
    throw new Error( 'useAssinaturaPresente deve ser usado dentro de um AssinaturaPresenteProvider' )
  }

  const { state, setState } = context
  const { getDadosGlobaisAssociado, setErroRequisicao, setToastGeral } = useGlobal()

  const setErroCodigo = msgErro => {
    setState( prevState => ( {
      ...prevState,
      'erroCodigo': msgErro
    } ) )
  }

  const setCodigoResgate = texto => {
    setState( prevState => ( {
      ...prevState,
      'codigoResgate': texto
    } ) )
  }

  const setDadosAssinaturaPresente = texto => {
    setState( prevState => ( {
      ...prevState,
      'dadosAssinaturaPresente': texto
    } ) )
  }

  const verificarCodigoResgate = async() => {
    if ( state.codigoResgate ) {
      try {
        const { 'data': dados } = await postCodigoResgate( state.codigoResgate )
        if ( !isEmptyObject( dados ) ) {
          setDadosAssinaturaPresente( dados )
          setErroCodigo( '' )
          return dados
        }
      } catch ( erro ) {
        if ( erro.response?.data?.errors?.length ) {
          setErroCodigo( erro.response.data.errors[ 0 ].message )
        } else {
          setErroCodigo( '' )
          setErroRequisicao( erro.response.status || erro.request.status )
        }
      }
    }
  }

  const resgatarPresente = async() => {
    const dadosResgate = await verificarCodigoResgate()
    if ( !isEmptyObject( dadosResgate ) ) {
      try {
        await postResgateAssinaturaPresente(
          dadosResgate.codigo,
          state.endereco.id,
        )

        setToastGeral( {
          'mensagem': SUCESSO_RESGATE,
          'show': true,
          'tipoToast': Toast.SUCCESS
        } )

        getDadosGlobaisAssociado()
      } catch ( erro ) {
        const isBadRequest = erro.response.status === httpStatus.BAD_REQUEST
        const temDetalhe = isBadRequest && erro.response.data?.errors?.length

        const descricao = temDetalhe ?
          {
            'descricao': erro.response.data.errors[ 0 ].message,
            'titulo': textoModalErro[ httpStatus.BAD_REQUEST ].titulo,
          } : {}
        setErroRequisicao( erro.response.status || erro.request.status, descricao )
      }
    }
  }

  const onChangeCodigo = event => {
    const { value } = event.target
    setCodigoResgate( value.toUpperCase() )
  }

  return {
    'codigoResgate': state.codigoResgate,
    'dadosAssinaturaPresente': state.dadosAssinaturaPresente,
    'erroCodigo': state.erroCodigo,
    onChangeCodigo,
    resgatarPresente,
  }
}

export { AssinaturaPresenteProvider, useAssinaturaPresente }
